import '../../../styles/adminVariables.css';
import styled from 'styled-components';


export const AdminButton = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  margin-bottom: 1rem;
`;
export const ActionButton = styled(AdminButton)`

  background-color: var(--action-bgcolor);
  color: white;
  border: 1px solid background-color;
  &:hover {
    background-color: #0056b3;

  }
`;

export const CancelButton = styled(AdminButton)`
  background-color: white;
  color: #007bff;
  border: 1px solid  #007bff;
  &:hover {
    background-color: #0056b3;

    color:white;
  }
  `;

export const IconButton = styled.button`
  background-color:inherit; 
  color:black;
  padding-right:.5rem;
  border:none;
  cursor:pointer;

  &:hover{
    color:purple
  }
`;